export default __webpack_public_path__ + "static/media/steeltype-new.02af6c26.svg";